export default {"src":"/_next/static/media/box.89269df4.svg","height":34,"width":91,"blurWidth":0,"blurHeight":0};